export enum ChangeImpediment {
    NONE = 'NONE',
    DUNNING_STATE = 'DUNNING_STATE',
    NON_REGIO_CONTRACTS = 'NON_REGIO_CONTRACTS',
    PRODUCT_CHANGE_IN_PROGRESS = 'PRODUCT_CHANGE_IN_PROGRESS',
    CHANGE_IN_PROGRESS = 'CHANGE_IN_PROGRESS',
    DATA_INVALID = 'DATA_INVALID',
}
